var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img src=\""
    + container.escapeExpression((lookupProperty(helpers,"avatarPlaceholder")||(depth0 && lookupProperty(depth0,"avatarPlaceholder"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"avatarPlaceholder","hash":{},"data":data,"loc":{"start":{"line":1,"column":10},"end":{"line":1,"column":36}}}))
    + "\" class=\"img-fluid rounded-circle lg\">";
},"useData":true});